/**
 * fileName       : models.js
 * author         : KDONG1224
 * date           : 2025-06-18
 * description    : POI 모델 목록
 * ===========================================================
 * DATE              AUTHOR             NOTE
 * -----------------------------------------------------------
 * 2025-06-18        KDONG1224       신창섭 차장님 요청으로 TEST 항목 비활성화 처리
 */
export const poiModels = [
  {
    key: 'a-frame-ladder',
    label: '사다리 A형',
    modelName: 'Ladder_A',
    url: '/assets/models/poi/a-frame-ladder/Ladder_A.FBX',
    texture: '/assets/models/poi/a-frame-ladder/Ladder_A.jpg',
    ext: 'FBX',
    image: '/assets/images/models/a-frame-ladder.webp',
    disabled: false,
    scale: [0.2, 0.2, 0.2]
  },
  {
    key: 'abc-fire',
    label: '소화기',
    modelName: 'ABC_Fire',
    url: '/assets/models/poi/abc-fire/ABC_Fire.FBX',
    texture: null,
    ext: 'FBX',
    image: '/assets/images/models/abc-fire.jpg',
    disabled: false,
    scale: [0.2, 0.2, 0.2]
  },
  {
    key: 'aerial-work-platform',
    label: '고소작업대',
    modelName: 'skywork',
    url: '/assets/models/poi/aerial-work-platform/skywork.FBX',
    texture: '/assets/models/poi/aerial-work-platform/SKYWORK.JPG',
    ext: 'FBX',
    image: '/assets/images/models/aerial-work-platform.webp',
    disabled: false,
    scale: [0.2, 0.2, 0.2]
  },
  {
    key: 'cargo-crane',
    label: '카고 크레인',
    modelName: 'crane',
    url: '/assets/models/poi/cargo-crane/crane.FBX',
    texture: '/assets/models/poi/cargo-crane/CRANE.JPG',
    ext: 'FBX',
    image: '/assets/images/models/cargo-crane.webp',
    disabled: false,
    scale: [0.07, 0.07, 0.07]
  },

  // {
  //   key: 'cargo-crane-50-81',
  //   label: '카고 크레인(TEST 50x81)',
  //   modelName: 'crane',
  //   url: '/assets/models/test/tt50x81.FBX',
  //   texture: null,
  //   ext: 'FBX',
  //   image: '/assets/images/models/tower-crane.webp',
  //   disabled: false,
  //   scale: [0.07, 0.07, 0.07]
  // },
  // {
  //   key: 'cargo-crane-60-50',
  //   label: '카고 크레인(TEST 60x50)',
  //   modelName: 'crane',
  //   url: '/assets/models/test/tt60x50.FBX',
  //   texture: '/assets/models/text/cargo-crane/CRANE.JPG',
  //   ext: 'FBX',
  //   image: '/assets/images/models/tower-crane.webp',
  //   disabled: false,
  //   scale: [0.07, 0.07, 0.07]
  // },

  {
    key: 'cargo-crane-lt50x50',
    label: '카고 크레인',
    modelName: 'lt50x50',
    url: '/assets/models/poi/cargo-crane/lt50x50.FBX',
    texture: '/assets/models/poi/cargo-crane/LT50X50.JPG',
    ext: 'FBX',
    image: '/assets/images/models/tower-crane.webp',
    disabled: true
  },
  {
    key: 'concrete-pump-truck',
    label: '펌프카',
    modelName: 'pumpcar',
    url: '/assets/models/poi/concrete-pump-truck/pumpcar.FBX',
    texture: '/assets/models/poi/concrete-pump-truck/PUMPCAR.JPG',
    ext: 'FBX',
    image: '/assets/images/models/concrete-pump-truck.webp',
    disabled: false,
    scale: [0.07, 0.07, 0.07]
  },
  {
    key: 'container-office',
    label: '컨테이너 사무소',
    modelName: 'fieldof',
    url: '/assets/models/poi/container-office/fieldof.FBX',
    texture: '/assets/models/poi/container-office/FIELDOF.JPG',
    ext: 'FBX',
    image: '/assets/images/models/container-office.webp',
    disabled: false,
    scale: [0.07, 0.07, 0.07]
  },
  {
    key: 'drilling-machine',
    label: '천공기',
    modelName: 'Boring',
    url: '/assets/models/poi/drilling-machine/Boring.FBX',
    texture: '/assets/models/poi/drilling-machine/BORING.JPG',
    ext: 'FBX',
    image: '/assets/images/models/drilling-machine.webp',
    disabled: false,
    scale: [0.07, 0.07, 0.07]
  },
  {
    key: 'dump-truck',
    label: '덤프트럭',
    modelName: 'dump',
    url: '/assets/models/poi/dump-truck/dump.FBX',
    texture: '/assets/models/poi/dump-truck/DUMP.JPG',
    ext: 'FBX',
    image: '/assets/images/models/dump-truck.webp',
    disabled: false,
    scale: [0.07, 0.07, 0.07]
  },
  {
    key: 'extension-ladder',
    label: '사다리 B형',
    modelName: 'Ladder_B',
    url: '/assets/models/poi/extension-ladder/Ladder_B.FBX',
    texture: '/assets/models/poi/extension-ladder/Ladder_B.jpg',
    ext: 'FBX',
    image: '/assets/images/models/extension-ladder.webp',
    disabled: false,
    scale: [0.2, 0.2, 0.2]
  },
  {
    key: 'forklift-highlander',
    label: '지게차',
    modelName: 'forklift',
    url: '/assets/models/poi/forklift-highlander/forklift.FBX',
    texture: '/assets/models/poi/forklift-highlander/FORKLIFT.JPG',
    ext: 'FBX',
    image: '/assets/images/models/forklift-highlander.webp',
    disabled: false,
    scale: [0.07, 0.07, 0.07]
  },
  {
    key: 'h-frame-ladder',
    label: '사다리 H형',
    modelName: 'Ladder_H',
    url: '/assets/models/poi/h-frame-ladder/Ladder_H.FBX',
    texture: '/assets/models/poi/h-frame-ladder/Ladder_H.jpg',
    ext: 'FBX',
    image: '/assets/images/models/h-frame-ladder.webp',
    disabled: false,
    scale: [0.2, 0.2, 0.2]
  },
  {
    key: 'loader',
    label: '로더',
    modelName: 'loader',
    url: '/assets/models/poi/loader/loader.FBX',
    texture: '/assets/models/poi/loader/LOADER.JPG',
    ext: 'FBX',
    image: '/assets/images/models/loader.webp',
    disabled: false,
    scale: [0.07, 0.07, 0.07]
  },
  {
    key: 'roller',
    label: '롤러',
    modelName: 'roller',
    url: '/assets/models/poi/roller/roller.FBX',
    texture: '/assets/models/poi/roller/ROLLER.JPG',
    ext: 'FBX',
    image: '/assets/images/models/roller.webp',
    disabled: false,
    scale: [0.07, 0.07, 0.07]
  },
  {
    key: 'sky-lift',
    label: '스카이',
    modelName: 'skycar',
    url: '/assets/models/poi/sky-lift/skycar.FBX',
    texture: '/assets/models/poi/sky-lift/SKYCAR.JPG',
    ext: 'FBX',
    image: '/assets/images/models/sky-lift.webp',
    disabled: false,
    scale: [0.07, 0.07, 0.07]
  }
];
